module.exports = __webpack_public_path__ + "img/ui_material_design.06ba978d.jpg";